module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('popup-select', {
    ref: "popupSelect",
    attrs: {
      "id": "hospital-select",
      "custom": true,
      "title": '选择医院',
      "forced": _vm.forced
    },
    model: {
      value: (_vm.selectedHospital),
      callback: function($$v) {
        _vm.selectedHospital = $$v
      },
      expression: "selectedHospital"
    }
  }, [_vm._t("default", [_c('ul', {
    staticClass: "list list-select"
  }, [_c('li', {
    staticClass: "list-item"
  }, [_c('div', {
    staticClass: "hospital arr-row ellipsis",
    attrs: {
      "id": "hospitalSelect-div-hospitalName"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.selectedHospital.hospitalName) + "\n        ")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "custom",
      "id": "hospitalSelect-tree"
    },
    slot: "custom"
  }, [_c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.hospitalList), function(hospital) {
    return _c('li', {
      key: hospital.hospitalId,
      staticClass: "list-item arr-row",
      attrs: {
        "id": 'hospitalSelect-li-hospital-' + hospital.hospitalId
      },
      on: {
        "click": function($event) {
          return _vm.select(hospital)
        }
      }
    }, [_c('div', {
      staticClass: "hospital-info"
    }, [_c('div', {
      staticClass: "logo",
      style: ({
        backgroundImage: hospital.hospitalLogo ?
          ("url(" + (hospital.hospitalLogo) + ")") :
          'url(../../../static/img/hos-def-logo.png)'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "info"
    }, [_c('p', {
      staticClass: "f-large f-normal ellipsis"
    }, [_vm._v("\n              " + _vm._s(hospital.hospitalName || '未知医院') + "\n            ")]), _vm._v(" "), _c('p', {
      staticClass: "f-small f-dark-gray ellipsis"
    }, [_vm._v("\n              " + _vm._s(hospital.hospitalAddr || '地址信息未提供') + "\n            ")])])]), _vm._v(" "), (hospital.weapp) ? _c('div', {
      staticClass: "weapp-launch-wrap"
    }, [(hospital.weapp) ? _c('wx-open-launch-weapp', {
      staticClass: "weapp-launch-layer",
      attrs: {
        "appid": hospital.weapp.appid,
        "username": hospital.weapp.username,
        "path": hospital.weapp.path
      },
      on: {
        "launch": _vm.handleWeappLaunch,
        "error": _vm.handleWeappError
      }
    }, [_c('script', {
      attrs: {
        "type": "text/wxtag-template"
      }
    }, [_vm._v("\n              <style>\n                .weapp-launch-btn {\n                  width: 750px;\n                  height: 100px;\n                  border: none;\n                  background: #fff;\n                }\n              </style>\n              <div class=\"weapp-launch-btn\"></div>\n            ")])]) : _vm._e()], 1) : _vm._e()])
  }), 0), _vm._v(" "), _c('no-record', {
    attrs: {
      "condition": _vm.hospitalList.length === 0,
      "tips": "抱歉，暂无医院列表信息"
    }
  })], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a84fe82e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/internetHospital/internetHospital.vue
// module id = 868
// module chunks = 0